import React from 'react';
import { type Header } from '@tanstack/react-table';

import { EFilterType } from '../../types/table';
import { IIncludesStringFilterProps, IncludesStringFilter } from './IncludesStringFilter';
import { InDateRangeFilter } from './InDateRangeFilter';
import { InNumberRangeFilter } from './InNumberRangeFilter';
import { MultiSelectFilter } from './MultiSelectFilter';
import { SelectFilter } from './SelectFilter';

const filterTypeToComponent: Record<EFilterType, React.FC<IIncludesStringFilterProps>> = {
    [EFilterType.includesString]: IncludesStringFilter,
    [EFilterType.inNumberRange]: InNumberRangeFilter,
    [EFilterType.equalsSelect]: SelectFilter,
    [EFilterType.multiSelect]: MultiSelectFilter,
    [EFilterType.inDateRange]: InDateRangeFilter,

    [EFilterType.dispatcherState]: IncludesStringFilter,
    [EFilterType.offerState]: IncludesStringFilter,
};

export interface IFilterContentProps {
    header: Header<any, unknown>;
    inline?: boolean;
}

export const FilterContent: React.FC<IFilterContentProps> = ({ header, inline = false }) => {
    const filter = header.column.columnDef.meta?.filtering;
    const CustomFilterComponent = header.column.columnDef.meta?.filterComponent;

    if (header.column.getCanFilter() === false || filter === undefined) return null;

    if (CustomFilterComponent) {
        return <CustomFilterComponent header={header} inline={inline} />;
    }

    const FilterComponent = filterTypeToComponent[filter.type as EFilterType];

    return <FilterComponent header={header} type={filter.type} inline={inline} />;
};
